
    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import BookingActionDetailModal  from "@/views/Modals/BookingsModals/BookingActionDetailModal.vue";
    import * as toastr from "toastr";
    import { ApiClient } from "@/utilities/ApiClient";
    import { BookingAction } from "@/model/BookingAction";
    import { BookingActionVM, IBookingActionVM } from "@/model/Api/VM/BookingActionVM";
    import { Utils } from "@/utilities/Utils";
    import EmployeeScanHistoryModal  from "@/views/Modals/EmployeesModals/EmployeeScanHistoryModal.vue";
    import { RedFlagMessageType, BookingActionDirection, BookingActionResult, ScanTiming, ScanMedium } from "@/model/Enums";
    
    @Component({
        components: {
            ApiButton,
            BookingActionDetailModal,
            EmployeeScanHistoryModal
        }
    })

    export default class ScanReportModal extends Vue {

        //
        // -- properties
        //

        private bookingID: number = 0;
        private bookingActions: Array<IBookingActionVM> = [];
        private openEmployees: Array<number> = [];

        private get messageType() {
            return Utils.enumToLookups(RedFlagMessageType);
        }

        private get directionType() {
            return Utils.enumToLookups(BookingActionDirection);
        }

        private get resultType() {
            return Utils.enumToLookups(BookingActionResult);
        }

        private get timingOptions() {
            return Utils.enumToLookups(ScanTiming);
        }

        private get mediumOptions() {
            return Utils.enumToLookups(ScanMedium);
        }

        showRedFlag(data: BookingAction) {
            if (data.redFlagMessageType == RedFlagMessageType.None) {
                return false;
            }
            else {
                return true;
            }
        }

        //
        // -- methods
        //

        open(bookingID: number) {
            this.bookingID = bookingID;
            this.loadScanReportData();
            this.$bvModal.show("scanReportModal");
        }

        async loadScanReportData() {
            this.bookingActions = [];
            const response = await ApiClient.get(`/Api/Booking/BookingActions?id=${this.bookingID}`);
            this.bookingActions.push(...response.map((r: IBookingActionVM) => new BookingActionVM(r)));

            this.openEmployees.forEach(e => {
                this.bookingActions.forEach(a => {
                    if (a.employeeID == e) {
                        a.actionsVisible = true;
                    }
                })
            })

            this.openEmployees = [];
        }

        openRedFlag(id: number, name: string, event: Event) {
            const dialogue = this.$refs.employeeScanHistoryModal as EmployeeScanHistoryModal & { show: () => void };
            dialogue.open(id, name, true);
        }

        toggleActionsVisible(action: BookingActionVM) {
            if (action.actionsVisible) {
                action.actionsVisible = false;
            } else {
                action.actionsVisible = true;
            }
        }

        openActionDetail(id: string) {
            const dialogue = this.$refs.bookingActionDetailModal as BookingActionDetailModal & { show: () => void };
            dialogue.open(id);
        }
        
        cancel() {
            this.bookingActions = [];
            this.openEmployees = [];
            this.$bvModal.hide("scanReportModal");
        }

        async saveActionResolution(action: BookingAction, event: Event) {
            if (action.resolvedComments.length == 0) {
                toastr.warning("Please enter a resolution before saving.")
                return;
            }

            this.bookingActions.forEach(action => {
                if (action.actionsVisible) {
                    this.openEmployees.push(action.employeeID);
                }
            });

            const postData = {
                id: action.id,
                resolvedComments: action.resolvedComments
            }

            await ApiClient.post("/Api/Booking/SaveBookingAction", postData, event);
            toastr.success("Saved");

            this.loadScanReportData();
        }

        async downloadScanReport() {
            const blob: Blob = await ApiClient.get(`/api/report/scanReport?bookingID=${this.bookingID}`);
            Utils.downloadBlob(document, blob, `ScanReport_${this.bookingID}.pdf`);
        }

        async downloadDetailedScanReport(event: Event, employeeID: number) {
            const hasData: boolean = await ApiClient.get(`/api/booking/EmployeeDetailedScanReportDataCheck?bookingID=${this.bookingID}&employeeID=${employeeID}`);
            if (hasData) {
                const blob: Blob = await ApiClient.get(`/api/report/EmployeeDetailedScanReport?bookingID=${this.bookingID}&employeeID=${employeeID}`);
                Utils.downloadBlob(document, blob, `EmployeeScanReport_${this.bookingID}.pdf`);
            }
            if (!hasData) {
                toastr.warning("No data yet available for this employee")
            }
        }
    }

